
// css
import './css/sidenav.css'

const Sidenav = ({updateRailWayCounter, counter}) => {
	return(
			<div className="sidenav_main_container">
				<div className="side_buttons_container">
					<p onClick={() => updateRailWayCounter(0)} id="sidenav_id_0" ><i  className={counter===0?"fas fa-user sidenav_active_0":"fas fa-user not_sidenav_active_0"}></i></p>
					<p onClick={() => updateRailWayCounter(1)} id="sidenav_id_1" ><i  className={counter===1?"fas fa-fire-alt sidenav_active_1":"fas fa-fire-alt not_sidenav_active_0"}></i></p>
					<p onClick={() => updateRailWayCounter(2)} id="sidenav_id_2" ><i  className={counter===2?"fas fa-couch sidenav_active_2":"fas fa-couch not_sidenav_active_0"}></i></p>
					<p onClick={() => updateRailWayCounter(3)} id="sidenav_id_3" ><i  className={counter===3?"fas fa-flask sidenav_active_3":"fas fa-flask not_sidenav_active_0"}></i></p>
					<p onClick={() => updateRailWayCounter(4)} id="sidenav_id_4" ><i  className={counter===4?"fas fa-comment-alt sidenav_active_4":"fas fa-comment-alt not_sidenav_active_0"}></i></p>
					<p onClick={() => updateRailWayCounter(5)} id="sidenav_id_5" ><i  className={counter===5?"fas fa-briefcase sidenav_active_5":"fas fa-briefcase not_sidenav_active_0"}></i></p>
				</div>
			</div>
		)
}

export default Sidenav